import axios from "axios";
import { toast } from 'react-toastify';
import * as types from '../constants/ActionTypes';

// const getCSAProductListUrl = `${process.env.REACT_APP_API_URL}api/csa-app/item-enquiry`;
const getPriceDetailsUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaproduct/get-price-details`;
const getStoreSohUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaproduct/get-store-soh`;
const getCSAProductListUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/item-enquiry`;
const getApplicableSchemesUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaproduct/get-applicable-schemes`;
const getSerialNoDetailsUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaproduct/get-serialNo-details`;
const resetDbSessionUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaproduct/reset-db-session`;
const getSchemesUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaproduct/get-schemes`;
//const getCountryListUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/get-country-list`;


const getCSAProductListRequest = () => ({
    type: types.CSA_PRODUCT_LIST_REQUEST,
})

const getCSAProductListSuccess = (data) => ({
    type: types.CSA_PRODUCT_LIST_SUCCESS,
    data
})

const getCSAProductListFailure = (error) => ({
    type: types.CSA_PRODUCT_LIST_FAILURE,
    error
})
// const countryListSuccess = data => ({
//   type: types.COUNTRY_LIST_SUCCESS,
//   data
// });

// const countryListRequested = () => ({
//   type: types.COUNTRY_LIST_REQUEST
// });

// const countryListFailure = error => ({
//   type: types.COUNTRY_LIST_FAILURE,
//   error
// });

const getPriceDetailsRequest = () => ({
  type: types.PRICE_DETAILS_REQUEST,

})

const getPriceDetailsSuccess = (data) => ({
  type: types.PRICE_DETAILS_SUCCESS,
  data
})

const getPriceDetailsFailure = (error) => ({
  type: types.PRICE_DETAILS_FAILURE,
  error
})

const getSerialNoDetailsRequest = () => ({
  type: types.SERIALNO_REQUEST,

})

const getSerialNoDetailsSuccess = (data) => ({
  type: types.SERIALNO_SUCCESS,
  data
})

const getSerialNoDetailsFailure = (error) => ({
  type: types.SERIALNO_FAILURE,
  error
})

const resetDbSessionRequest = () => ({
  type: types.RESETDBSESSION_REQUEST,

})

const resetDbSessionSuccess = (data) => ({
  type: types.RESETDBSESSION_SUCCESS,
  data
})

const resetDbSessionFailure = (error) => ({
  type: types.RESETDBSESSION_FAILURE,
  error
})

const getStoreSohRequest = () => ({
  type: types.STORE_SOH_REQUEST,

})

const getStoreSohSuccess = (data) => ({
  type: types.STORE_SOH_SUCCESS,
  data
})

const getStoreSohFailure = (error) => ({
  type: types.STORE_SOH_FAILURE,
  error
})

const getSchemesRequest = () => ({
  type: types.SCHEMES_REQUEST,

})

const getSchemesSuccess = (data) => ({
  type: types.SCHEMES_SUCCESS,
  data
})

const getSchemesFailure = (error) => ({
  type: types.SCHEMES_FAILURE,
  error
})

const getApplicableSchemesRequest = () => ({
  type: types.APPLICABLE_SCHEMES_REQUEST,
})

const getApplicableSchemesSuccess = (data) => ({
  type: types.APPLICABLE_SCHEMES_SUCCESS,
  data
})

const getApplicableSchemesFailure = (error) => ({
  type: types.APPLICABLE_SCHEMES_FAILURE,
  error
})

const getCsaProductSearchValues = (data) => ({
  type: types.CSA_PRODUCT_SEARCH_VALUES,
  data,
})

export const getCSAProductList = (options) => {
  return async dispatch => {
    try {
      dispatch(getCSAProductListRequest())
      
      const response = await
        axios.get(getCSAProductListUrl, {
        
         params : {
           connection_id: options.connection_id,
                 product_id: options.product_id,
                 sku_id:options.sku_id,
                 barcode:options.barcode,
                 store_flag:options.store_flag,
                 tenant_category : options.tenant_category,
                 size_id:  options.size_id,
                 color_id:  options.color_id,
                 brand_code:options.brand_code,
                 category_id:options.category_id,
                 gender_id:options.gender_id,               
                 new_arrivals:options.new_arrivals,
                 price_start_range:options.price_start_range,
                 price_end_range:options.price_end_range,
                 tenant_name : options.tenant_name,
                
               page:options.page
          
         }
        
       })

      // axios.post(getCSAProductListUrl, options, {
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      //     //'Content-Type': 'application/json; charset=UTF-8'
      //   },
      // })
      
      .then(res => res.data);
      if (response.ack === "Success") {
        if(options.store_flag === 'AL' && response.results.product_details.length > 0){
                                            localStorage.setItem('fromAll','yes') 

        }else {
          localStorage.removeItem('fromAll')
        }
                      //  if(response.results.product_details.length === 0 && options.store_flag === 'TS'){
                         
                      //     options.store_flag='AL'
                      //    const responseOne = await axios.post(getCSAProductListUrl, options, {
                      //                             headers: {
                      //                               'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                      //                               //'Content-Type': 'application/json; charset=UTF-8'
                      //                             },
                      //                           }).then(res=>res.data);
                      //                           if(responseOne.results.product_details.length > 0 ){
                      //                           localStorage.setItem('fromAll','yes') 
                      //                           }
                                              
                      //                       dispatch(getCSAProductListSuccess(responseOne.results));
                                                  
                          
                      //  }else {
                       dispatch(getCSAProductListSuccess(response.results)); }
                      // }
                      else if (response.ack === "Failure") {
                                         toast.error(`Failed - ${response.status.message}`);
                                         dispatch(getCSAProductListFailure(response.status));
                                       }     
     

    }
    catch(error) {
      dispatch(getCSAProductListFailure(error));
    }

    return 'done';
  }
}

//get price detail for GDIM
export const getPriceDetails = (options) => {
  return async dispatch => {
    try {
      dispatch(getPriceDetailsRequest())
      
      const response = await
        axios.get(getPriceDetailsUrl, {
        
         params : {
           connection_id: options.connection_id,
                 product_id: options.product_id,
                 web_session_id : options.web_session_id,

         }
        
       })     
      .then(res => res.data);
      if (response.ack === "Success") {
        
                  
                       dispatch(getPriceDetailsSuccess(response.results)); }
                      
                      else if (response.ack === "Failure") {
                                         toast.error(`Failed - ${response.status.message}`);
                                         dispatch(getPriceDetailsFailure(response.status));
                                       }     
     

    }
    catch(error) {
      dispatch(getPriceDetailsFailure(error));
    }

    return 'done';
  }
}
//get store soh detail for puma
export const getStoreSoh = (options) => {
  return async dispatch => {
    try {
      dispatch(getStoreSohRequest())

      const response = await
        axios.get(getStoreSohUrl, {

          params: {
            connection_id: options.connection_id,
            sku_cd: options.sku_cd,
            fromStore: options.fromStore

          }

        })
          .then(res => res.data);
      if (response.ack === "Success") {


        dispatch(getStoreSohSuccess(response.results));
      }

      else if (response.ack === "Failure") {
        toast.error(`Failed - ${response.status.message}`);
        dispatch(getStoreSohFailure(response.status));
      }


    }
    catch (error) {
      dispatch(getStoreSohFailure(error));
    }

    return 'done';
  }
}
export const getSchemes = (options) => {
  return async dispatch => {
    try {
      dispatch(getSchemesRequest())
      
      const response = await
        axios.get(getSchemesUrl, {
        
         params : {
           connection_id: options.connection_id,
                 product_id: options.product_id,
                 web_session_id : options.web_session_id,

         }
        
       })     
      .then(res => res.data);
      if (response.ack === "Success") {
        
                  
                       dispatch(getSchemesSuccess(response.results)); }
                      
                      else if (response.ack === "Failure") {
                                         toast.error(`Failed - ${response.status.message}`);
                                         dispatch(getSchemesFailure(response.status));
                                       }     
     

    }
    catch(error) {
      dispatch(getSchemesFailure(error));
    }

    return 'done';
  }
}

// export const getCountryList = (connection_id, username) => {
//   return dispatch => {
//     dispatch(countryListRequested());

//     return axios.get(getCountryListUrl, {
//       params: { connection_id, username }
//     })
//     .then(res => {
//       if (res.data.ack === "Success") {
//         console.log(res)
//         dispatch(countryListSuccess(res.data.results));
//       } else {
//         dispatch(countryListFailure(res.data.status));
//       }
//     })
//     .catch(err => {
//       dispatch(countryListFailure(err.message));
//       throw err; // optional, if caller should catch
//     });
//   };
// };


export const getSerialNoDetails = (data) => {

  return async dispatch => {
    try {
    dispatch(getSerialNoDetailsRequest());
    const response = await  axios.get(getSerialNoDetailsUrl,
      {
        
        params : {
          connection_id: data.connection_id,
                product_id: data.product_id,
                web_session_id : data.web_session_id,
                qty:data.qty,
                ean : data.ean,
                tenant_category : data.tenant_category,
                RID_CART_ORDER_TYPE : data.RID_CART_ORDER_TYPE,
                ORDER_SUB_TYPE:data.ORDER_SUB_TYPE,
                 RID_LOT_CD : data.RID_LOT_CD ,
              RID_FREE_ITEM : data.RID_FREE_ITEM ,
              SCAN_TYPE : data.SCAN_TYPE ,
              RID_RFID_TAG_SLNO : data.RID_RFID_TAG_SLNO ,
              RID_SALES_MAN_CODE : data.RID_SALES_MAN_CODE,
              RID_PROCEED_WITH_EAN : data.RID_PROCEED_WITH_EAN ,
              RID_PROCEED_WITH_GLOBAL_ORDER : data.RID_PROCEED_WITH_GLOBAL_ORDER,
              PICKUP_LOC_TYPE : data.PICKUP_LOC_TYPE  
        }
       
      })
      .then(res => res.data);
      if (response.ack === "Success") {
        localStorage.removeItem('fromAll') 
                  
                       dispatch(getSerialNoDetailsSuccess(response.results));
                       dispatch(resetDbSession({
          connection_id: data.connection_id,
          web_session_id: data.web_session_id
        }));
                      
                      }
                       
                      
                      else if (response.ack === "Failure") {
                                         toast.error(`Failed - ${response.status.message}`);
                                         dispatch(getSerialNoDetailsFailure(response.status));
                                       }     
     

    }
    catch(error) {
      dispatch(getSerialNoDetailsFailure(error));
    }
  };
};
export const resetDbSession = (data) => {

  return async dispatch => {
    try {
    dispatch(resetDbSessionRequest());
    const response = await  axios.get(resetDbSessionUrl,
      {
        
        params : {
          connection_id: data.connection_id,
                
                web_session_id : data.web_session_id                
        }
       
      })
      .then(res => res.data);
      if (response.ack === "Success") {
                  
                       dispatch(resetDbSessionSuccess(response.results)); }
                      
                      else if (response.ack === "Failure") {
                                         toast.error(`Failed - ${response.status.message}`);
                                         dispatch(resetDbSessionFailure(response.status));
                                       }     
     

    }
    catch(error) {
      dispatch(resetDbSessionFailure(error));
    }
  };
};
export const getApplicableSchemes = (data) => {

  return async dispatch => {
    try {
    dispatch(getApplicableSchemesRequest());
    const response = await  axios.get(getApplicableSchemesUrl,
      {
        
        params : {
          connection_id: data.connection_id,
                product_id: data.product_id,
                web_session_id : data.web_session_id,
                qty:data.qty,
                ean : data.ean,
                RID_CART_ORDER_TYPE : data.RID_CART_ORDER_TYPE,
                ORDER_SUB_TYPE:data.ORDER_SUB_TYPE
        }
       
      })
      .then(res => res.data);
      if (response.ack === "Success") {
                  
                       dispatch(getApplicableSchemesSuccess(response.results)); }
                      
                      else if (response.ack === "Failure") {
                                         toast.error(`Failed - ${response.status.message}`);
                                         dispatch(getApplicableSchemesFailure(response.status));
                                       }     
     

    }
    catch(error) {
      dispatch(getApplicableSchemesFailure(error));
    }
  };
};

// export const getCSAProductList = (options) => {
//     return dispatch => {
      
      
//         dispatch(getCSAProductListRequest())
//         axios.post(getCSAProductListUrl, options, {
//             headers: {
//               'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
//               //'Content-Type': 'application/json; charset=UTF-8'
//             },
//           })
//             .then(res => {
            
//               if (res.data.ack === "Success") {
//                 if(res.data.results.product_details.length === 0 && options.store_flag === 'TS'){
                 
//                   options.store_flag='AL'
                  
//                   axios.post(getCSAProductListUrl, options, {
//                       headers: {
//                         'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
//                         //'Content-Type': 'application/json; charset=UTF-8'
//                       },
//                     })
//                     .then(res => {
//                       if(res.data.results.product_details.length > 0 ){
//                       localStorage.setItem('fromAll','yes') 
//                       }
                  
//                       dispatch(getCSAProductListSuccess(res.data.results));
                      
//                     })
                   
//                 }

//                 dispatch(getCSAProductListSuccess(res.data.results));
//               } else if (res.data.ack === "Failure") {
//                 toast.error(`Failed - ${res.data.status.message}`);
//                 dispatch(getCSAProductListFailure(res.data.status));
//               }
//             })
//             .catch(err => {
//               throw err;
//               // dispatch(addTodoFailure(err.message));
//             });
//     }
// }



export const sendCsaProductSearchValue = (options) => {
  return dispatch => {
      dispatch(getCsaProductSearchValues(options))
  }
}